export default "__VITE_ASSET__DKb4RjcJ__"